import { Component, ErrorHandler, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { LaskuKatseleComponentData, LaskuKatseleComponentDataResolve, LaskuKatseleComponentExistingData } from '../_angular/_resolvers/lasku.resolve'
import { LaskuService } from '../_angular/service/lasku/lasku.service'

import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuTeeTilaJaIndeksiUudelleenComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>()

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private laskuService: LaskuService,
    private laskuKatseleComponentDataResolve: LaskuKatseleComponentDataResolve,
    private errorHandler: ErrorHandler,
  ) {}

  ngOnInit() {
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: { data: LaskuKatseleComponentData }) => {
      this.laskuService
        .paivitaTilaJaIndeksoiUudelleen(data.data.juurilasku)
        .then(({ juurilasku, kasiteltava }) => {
          const newData: LaskuKatseleComponentExistingData = {
            juurilasku: juurilasku,
            kasiteltava: kasiteltava,
          }
          this.laskuKatseleComponentDataResolve.asetaOlemassaolevaData(newData)
          this.router.navigate(['laskutus/laskut', juurilasku.avain, kasiteltava.avain, 'katsele'])
        })
        .catch(err => {
          this.errorHandler.handleError(err)
        })
    })
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }
}
